module.exports = __webpack_public_path__ + "img/SOUTHASIA_NUTS.95797e71.png";